import styled from 'styled-components'

export const NavigationTabsComponent = styled.div`
  margin-bottom: 20px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin-bottom: 30px;
  }

  .tabs-list {
    position: relative;
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;
    flex-direction: row;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      flex-wrap: initial;
    }
  }

  .tabs-list-item {
    padding: 10px;
    min-height: 60px;
    background: ${ (props) => props.theme.colors.weiss };
    text-decoration: none;
    box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-top: 6px solid ${ (props) => props.theme.colors['aok-gruen'] };
    position: relative;
    cursor: pointer;
    width: calc(50% - 4px);
    margin: 0 0 10px;

    &:not(:first-child) {
      margin-left: 4px;
    }

    &:not(:last-child) {
      margin-right: 4px;
    }

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      width: auto;
      flex-grow: 1;
      max-width: none;
      flex-basis: 100%;
      min-height: 75px;

      &:not(:first-child) {
        margin-left: 4px;
      }

      &:not(:last-child) {
        margin-right: 4px;
      }
    }

    &.active {
      cursor: auto;
      color: ${ (props) => props.theme.colors.weiss };
      background-color: ${ (props) => props.theme.colors['panel-inner-border'] };
      border-top-color: ${ (props) => props.theme.colors.grau1 };

      @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
        &::after {
          content: ' ';
          position: absolute;
          left: calc(50% - 5px);
          width: 10px;
          height: 10px;
          bottom: -5px;
          transform: rotate(45deg);
          -webkit-print-color-adjust: exact;
          color-adjust: exact;
          background-color: ${ (props) =>
            props.theme.colors['panel-inner-border'] };
          box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);
        }
      }
    }
  }
`
